import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  TextField,
  styled,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import httpclient from "../../utils";
import SelectView from "../../Components/SelectView";
import ButtonDropDown from "../../Components/ButtonDropDown";
import PrintDialog from "../../Components/PrintDialog";
import TableComponentView from "../../Components/TableComponentView";
import { Masonry } from "@mui/lab";
import OrderCard from "../../Components/Warehouse/OrderCard";
import ViewOrderList from "../../Components/Warehouse/ViewOrderList";
import { useParams } from "react-router-dom";
import { useTheme } from "styled-components";
import GlobalURL from "../../utils/global";

const columns = [
  // { id: "id", name: "ID" },
  { id: "check", name: " " },
  { id: "number", name: "Order Number" },
  { id: "clientName", name: "Client" },
  { id: "added", name: "Added Date" },
  { id: "lastModified", name: "Updated Date" },
  { id: "total", name: "Total" },
  { id: "items", name: "Items" },
  { id: "actions", name: "Actions" },
];

const SearchBox = styled(Box)(({ theme }) => ({
  "& input": {
    padding: "12px",
  },
}));

const OrderHistory = () => {
  const configRowPerPage = JSON.parse(localStorage.getItem("configRowPerPage"));
  const {id} = useParams();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


  const [view, setView] = useState(2);
  const [searchText2, setSearchText2] = useState("");
  const [filteredData2, setFilteredData2] = useState([]);
  const [fulfilledOrderList, setFulfilledOrderList] = useState([])

  const [pageFul, setPageFul] = useState(1);
  const [fromFul, setFromFul] = useState(1);
  const [toFul, setToFul] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPageFul, setRowsPerPageFul] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalFul, setTotalFul] = useState("");
  const [lastPageFul, setLastPageFul] = useState("");

  const [dateFilter, setDateFilter] = useState("1Day");

  const [showPrintDialog, setShowPrintDialog] = useState(false);
  const [printDetails, setPrintDetails] = useState("");
  const [checkedValues, setCheckedValues] = useState([]);
  const [openViewDetails, setOpenViewDetails] = useState(false);
  const [viewDetails, setViewDetails] = useState({})
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getFulfilledOrders();
    setCheckedValues([]);
  },[]);

  const handleView = (num) => {
    setView(num);
    localStorage.setItem("view", JSON.stringify(num));
  };

  const callbackPrintPreview = (call) => {
    if (call.open === false) {
      setShowPrintDialog(false);
      setPrintDetails("");
      // setCheckedValues([]);
        setCheckedValues([]);
    }
  };

  const sendViewDetails = (call) => {
    if (call.open === false) {
      setOpenViewDetails(false);
      setViewDetails("");
    }
  };

  const getFulfilledOrders = (value) => {
    setLoading(true);
    httpclient
      .get(`wms/fulfilled/order?warehouseID=${id}&date=${value}`)
      .then(({ data }) => {
        if (data.success) {
          setFulfilledOrderList(data.records.data);
          setLoading(false);
          setFilteredData2(data.records.data);

          setTotalFul(data.records.total);
          setRowsPerPageFul(parseInt(data.records.per_page));
          setPageFul(data.records.current_page);
          setFromFul(data.records.from);
          setLastPageFul(data.records.last_page);

          setToFul(data.records.to);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleFulfilledPage = (e, page) => {
    setLoading(true);
    httpclient
      .get(
        `wms/fulfilled/order?warehouseID=${id}&date=${dateFilter}&page=${page}&recordsOnPage=${rowsPerPageFul}&readyToFulfill=1&keywords=${searchText2}&isExpress=2`
      )
      .then(({ data }) => {
        if (data.success) {
          setFulfilledOrderList(data.records.data);
          setLoading(false);
          setFilteredData2(data.records.data);

          setTotalFul(data.records.total);
          setRowsPerPageFul(parseInt(data.records.per_page));
          setPageFul(data.records.current_page);
          setFromFul(data.records.from);
          setLastPageFul(data.records.last_page);

          setToFul(data.records.to);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleFulfilledRows = (e) => {
    setRowsPerPageFul(e.target.value);
    localStorage.setItem("configRowPerPage", e.target.value);

    setLoading(true);
    httpclient
      .get(
        `wms/fulfilled/order?warehouseID=${id}&date=${dateFilter}&page=${1}&recordsOnPage=${e.target.value}`
      )
      .then(({ data }) => {
        if (data.success) {
          setFulfilledOrderList(data.records.data);
          setLoading(false);
          setFilteredData2(data.records.data);

          setTotalFul(data.records.total);
          setRowsPerPageFul(parseInt(data.records.per_page));
          setPageFul(data.records.current_page);
          setFromFul(data.records.from);
          setLastPageFul(data.records.last_page);

          setToFul(data.records.to);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleKeyDown2 = (e) => {
    if (e.key === "Enter") {
      handleSearchFulfilled();
    }
  };

  const handleChangeSearchFulfilled = (e) => {
    if (e.target.value === "") {
      getFulfilledOrders();
    }
    setSearchText2(e.target.value);
  };

  const handleSearchFulfilled = (e) => {
    httpclient
      .get(
        `wms/search/orders?warehouseID=${id}&readyToFulfill=1&keywords=${searchText2}&isExpress=2`
      )
      .then(({ data }) => {
        if (data.success) {
          setFulfilledOrderList(data.records.data);
          setLoading(false);
          setFilteredData2(data.records.data);

          setTotalFul(data.records.total);
          setRowsPerPageFul(parseInt(data.records.per_page));
          setPageFul(data.records.current_page);
          setFromFul(data.records.from);
          setLastPageFul(data.records.last_page);

          setToFul(data.records.to);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleChangeDateFilter = (e) => {
    setDateFilter(e.target.value);

    getFulfilledOrders(e.target.value);
  };

  const handleViewDetails = (order) => {
    setOpenViewDetails(true);
    setViewDetails(order);
  };

  const handleCheck = (e, row) => {
    const newCheckedValues = [...checkedValues];

    if (newCheckedValues.includes(row.id)) {
      if (e.target.checked === false) {
        var res = newCheckedValues.filter((che) => che !== row.id);
        setCheckedValues(res);
      }
    } else {
      newCheckedValues.push(row.id);
      setCheckedValues(newCheckedValues);
    }
  };

  const handlePrint = (option, order) => {
    // console.log("ordersssss is", order);
    setCheckedValues([order.id])

    setPrintDetails(
      `${GlobalURL[0].url}/getReceipt?warehouseID=${id}&salesDocumentIDs=${
        order.id
      }&size=${option === "Print" ? true : false}`
    );
    setShowPrintDialog(true);
  };

  const handleMultiplePrint = (option, order) => {
    let salesIDs = checkedValues.join(",");
    setPrintDetails(
      `${GlobalURL[0].url}/getReceipt?warehouseID=${id}&salesDocumentIDs=${salesIDs}&size=${
        option === "Print" ? true : false
      }`
    );
    setShowPrintDialog(true);
  };

  return (
    <>
    <Container maxWidth="xl">
      <Box
        pb={3}
        display={"flex"}
        alignItems={"center"}
        // flexDirection={isMobile ? "column" : "row"}
        justifyContent={"space-between"}
      >
        <Box flex={"1"}>
          <InputLabel>Search</InputLabel>
          <SearchBox display={"flex"}>
            <TextField
              type="search"
              variant="outlined"
              name="searchText2"
              value={searchText2}
              onChange={handleChangeSearchFulfilled}
              // onChange={(e) => setSearchText2(e.target.value)}
              helperText={
                searchText2 ? "Press enter to search Released Orders" : ""
              }
              onKeyDown={handleKeyDown2}
              sx={{ width: "300px" }}
            />
          </SearchBox>
        </Box>
        <Box textAlign={"center"} flex="1" marginTop={"10px"}>
          <h2>Released Orders</h2>
        </Box>
        <Box flex={"1"} textAlign={"right"} marginTop={"10px"}>
          <FormControl sx={{ width: "120px" }}>
            <InputLabel>Filter Date</InputLabel>
            <Select
              name="dateFilter"
              value={dateFilter}
              variant="outlined"
              label="Filter Date"
              onChange={handleChangeDateFilter}
            >
              <MenuItem value={"1Day"}>1 Day</MenuItem>
              <MenuItem value={"3Day"}>3 Days</MenuItem>
              <MenuItem value={"5Day"}>5 Days</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      {/* Change View */}
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <SelectView handleView={handleView} />
        {checkedValues.length > 0 ? (
          <Box textAlign={"right"} mb={2}>
            <ButtonDropDown
              checkedValues={checkedValues.length}
              handleClickPrint={handleMultiplePrint}
            />
          </Box>
        ) : (
          ""
        )}
      </Box>

      {!loading ? (
        view !== 1 ? (
          <>
            <TableComponentView
              columns={columns}
              rows={filteredData2}
              total={totalFul}
              from={fromFul}
              to={toFul}
              rowsPerPage={rowsPerPageFul}
              page={pageFul}
              handleChangePage={handleFulfilledPage}
              handleChangeRowsPerPage={handleFulfilledRows}
              handleViewDetails={handleViewDetails}
              handlePrint={handlePrint}
              fulfilled={true}
              handleCheck={handleCheck}
              checkedValues={checkedValues}
            />
          </>
        ) : (
          <>
            <Masonry
              columns={{ xs: 1, sm: 2, md: 3 }}
              spacing={3}
              sx={{ margin: "0", width: "auto" }}
            >
              {filteredData2 &&
                filteredData2.map((order) => (
                  <Box key={order.id}>
                    <OrderCard
                      order={order}
                      fulfilled={true}
                      handlePrint={handlePrint}
                    />
                  </Box>
                ))}
            </Masonry>
            {filteredData2.length ? (
              <Box
                alignItems={"center"}
                justifyContent={"center"}
                display={"flex"}
              >
                <Pagination
                  size="large"
                  count={lastPageFul}
                  page={pageFul}
                  onChange={handleFulfilledPage}
                  variant="outlined"
                  shape="rounded"
                  color="primary"
                />
              </Box>
            ) : (
              "No order Found!"
            )}
          </>
        )
      ) : (
        <Box textAlign={"center"}>
          <CircularProgress />
        </Box>
      )}

      {showPrintDialog && (
        <PrintDialog
          printDetails={printDetails}
          callbackPrintPreview={callbackPrintPreview}
        />
      )}

      {openViewDetails && (
        <ViewOrderList
          viewDetails={viewDetails}
          sendViewDetails={sendViewDetails}
        />
      )}
      </Container>
    </>
  );
};

export default OrderHistory;
